<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
      <b-row>
      <b-col>

          <b-form-group label="Errors" v-if="showDismissibleAlert">
              <b-alert variant="danger" :show="showDismissibleAlert"  @dismissed="showDismissibleAlert=false" dismissible fade>
              <span v-for="items in submissionError">
                <ul v-for="item in items">
                  <li> {{item}} </li>
                </ul>
             </span>
            </b-alert>
         </b-form-group>
      </b-col>
      </b-row>
       <b-row>
         <b-col>
            <h1 variant="primary">Please Scan Ticket</h1>
         </b-col>
       </b-row>
       <b-row>
        <b-col>
        <b-form-group label="" label-for="idNumber">
          <b-form-input id="idNumber" :state="validateState('idNumber')" name="idNumber" v-on:keyup.enter="processScannedCard"   aria-describedby="liveFeedbackIdNumber"  v-model.lazy.trim="$v.form.idNumber.$model" autofocus />
          <b-form-invalid-feedback id="liveFeedbackIdNumber">
             This is a required field.
           </b-form-invalid-feedback>
        </b-form-group>
        </b-col>
       </b-row>
      <b-row v-if="this.showTrayOption">
        <b-col>
          <b-form-group  label-for="trayRequired">
          <b-form-checkbox v-model="form.trayRequired" id="trayRequired" name="trayRequired" switch>
            Tray Required
          </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
        <b-button class="ml-1"  variant="secondary" @click="onReset">Reset</b-button>
        </b-col>
        </b-col>
        <b-col v-if="showPrintButton">
        <b-button class="ml-1"  variant="info" @click="callReceiptService">Re-Print</b-button>
        </b-col>

       </b-row>
    </b-card-body>
  </b-card>

</div>

</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

const formShape = {
  idNumber: null,
  isSecurity: false,
  trayRequired: false
}

const receiptShape = {
  receiptType: "samadh",
  visitdate: null,
  name: null,
  ismobprint: false,
  id: null,
  mobilecollected: 0,
  trayNo: null,
  totalVisited: null
}


export default {
  name: 'EntryStatusComponent',
  mixins: [validationMixin],
  props: {
    trayOption: {
      type: Boolean,
      default: false,
  	}

  },
  components: {},
  data: function() {
    return {
      form: Object.assign({}, formShape),
      receipt: Object.assign({}, receiptShape),
      submitted: false,
      showTrayOption: this.trayOption,
      showDismissibleAlert: false,
      submissionError: "",

      showPrintButton : false
    }
  },
  validations: {
    form: {
      idNumber: {
        required
        }
    }
  },
  computed: {
    isValid() {
      this.$v.$touch();
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    processScannedCard(){
      this.submitted = true
      this.showDismissibleAlert=false;
      this.submissionError = "";
      console.log(JSON.stringify(this.form, null, 4));
      if(this.isValid){
        this.$nextTick(() => {
          let params = JSON.stringify(this.form);
          this.$store.dispatch('samadh/updateVisitStatus', params)
            .then((response) => {
                if(response.data.success == false){
                  this.showErrorMsg({
                    message: response.data.error
                  });
                }
                else{
                  this.showSuccessMsg({
                    message: 'Record updated successfully.'
                  })
                  if(this.showTrayOption == true && this.form.trayRequired == true){
                      this.printReceipt(response.data.data)
                  }
                  else{
                    this.onReset();
                  }
                }


            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              }
              else if (error.response.status == 422){
                  this.showErrorMsg({
                    message: error.response.data.message
                  });
                  this.showDismissibleAlert=true;
                  var errors = Object.values(error.response.data.errors);
                  this.submissionError = errors;

              }
              else {
                this.showErrorMsg()
              }
              this.submitted = false

            })


        });
      }

    },
    onReset() {
      // Reset validation
      this.form.idNumber = "";
      this.form.isSecurity = this.trayOption;
      this.form.trayRequired = false;
      this.receipt = Object.assign({}, receiptShape);
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.showDismissibleAlert = false;
      this.submissionError = "";
      this.showPrintButton = false;
    },

    callReceiptService(){
      this.$nextTick(() => {
       let params = JSON.stringify(this.receipt);
       console.log(params);
       this.$store.dispatch('samadh/printReceipt', params)
         .then((response) => {
           console.log(response.data.status);
           if(response.data.status == 'error'){
               if(response.data.message != null){
                 this.showErrorMsg({
                 message: "Print Failed: " + response.data.message
               });
               }
               else{
                 this.showErrorMsg({
                   message: "Print Failed. Please check Print service is running."
                 });
               }

               this.showPrintButton = true;
             }
             else{
                 this.showPrintButton = false;
                 this.onReset();

             }
         })
         .catch((error) => {
           if(error.response != null && error.response.data.message != null){
             this.showErrorMsg({
               message: "Print Failed: " + error.response.data.message
             });
           }
           else{
             this.showErrorMsg({
               message: "Print Failed. Please check Print service is running."
             });
           }

           this.showPrintButton = true;

         })
   });

   },
   async printReceipt(data){

     this.receipt.receiptType = "samadh";
     this.receipt.visitdate = data.visitdate;
     this.receipt.name = data.visitorname;
     this.receipt.ismobprint = data.mobilesCollected > 0 ? true : false;
     this.receipt.id = data.uid;
     this.receipt.mobilecollected = data.mobilesCollected;
     this.receipt.trayNo =  data.trayNo;
     this.receipt.totalVisited = data.totalPeople;

     await this.callReceiptService();



   },




  },
  created () {
    this.form.idNumber = "";
    this.form.isSecurity = this.trayOption;
    this.form.trayRequired = false;

  },
  destroyed () {}

}

</script>
